import { request } from "./http";

export interface BrokerAccount {
  id: string;
  broker: string;
  account_label: string;
  mode: "paper" | "live";
  status: "active" | "revoked";
  last_verified_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface BrokerAccountCreate {
  broker: string;
  account_label: string;
  mode: "paper" | "live";
  credentials: Record<string, string>;
}

export const brokerAccounts = {
  list: () => request<BrokerAccount[]>("/piggy/api/broker-accounts"),
  create: (body: BrokerAccountCreate) =>
    request<BrokerAccount>("/piggy/api/broker-accounts", { body }),
  revoke: (broker: string, label: string) =>
    request<void>(`/piggy/api/broker-accounts/${broker}/${label}`, { method: "DELETE" }),
  test: (broker: string, label: string) =>
    request<{ ok: boolean; detail: string }>(`/piggy/api/broker-accounts/${broker}/${label}/test`, {
      method: "POST",
    }),
};
